import { createApi } from '@reduxjs/toolkit/query/react';
import { CompanyCommodity } from '@typeRoots/common/freight';
import { CheckListModalList } from '@typeRoots/common/checkListModal';
import { setCompanyCommodities, setCommodityList } from '../slice/freightSlice'; // Import actions from your slice
import { baseQueryWithProgress } from 'src/helpers/fetchQueryHelper';

export const freightApi = createApi({
  reducerPath: 'freightApi',
  baseQuery: baseQueryWithProgress,
  tagTypes: ['CompanyCommodities', 'CommodityList'],
  endpoints: (builder) => ({
    // Fetch commodities for a specific company
    getCompanyCommodities: builder.query<CompanyCommodity[], number>({
      query: (id) => `/commodities/company/${id}`,
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data: companyCommodities } = await queryFulfilled; // Fetch company commodities
          dispatch(setCompanyCommodities(companyCommodities)); // Dispatch to Redux store
        } catch (error) {
          console.log('Error fetching company commodities', error);
        }
      },
      providesTags: ['CompanyCommodities'],
    }),

    // Fetch the full list of commodities categorized by type
    getCommoditiesList: builder.query<CheckListModalList, void>({
      query: () => `/commodities`,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: commodityList } = await queryFulfilled; // Fetch full commodity list
          dispatch(setCommodityList(commodityList)); // Dispatch to Redux store
        } catch (error) {
          console.log('Error fetching commodities list', error);
        }
      },
      providesTags: ['CommodityList'],
    }),

    // Update commodities for a specific company
    updateCompanyCommodities: builder.mutation<
      CompanyCommodity[],
      { id: number; data: CompanyCommodity[] }
    >({
      query: ({ id, data }) => ({
        url: `/commodities/company/${id}`,
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      async onQueryStarted(_params, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedCompanyCommodities } = await queryFulfilled; // Get updated data from API response
          // Dispatch the updated data to Redux store
          dispatch(setCompanyCommodities(updatedCompanyCommodities));
        } catch (error) {
          console.log('Error updating company commodities', error);
        }
      },
      invalidatesTags: ['CompanyCommodities'],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCompanyCommoditiesQuery,
  useLazyGetCompanyCommoditiesQuery,
  useGetCommoditiesListQuery,
  useUpdateCompanyCommoditiesMutation,
} = freightApi;
